/* Desktop Navigation JS

  Params:
    mobileNavType = -none-
      Basic Desktop Navigation Behavior

    mobileNavType = clickMenus
      If tablet/mobile device, tapping navigation reveals
      sub-navigation panel instead of clicking through
*/

Foundation.View.Desktop.NavigationPanel = class {
  constructor (selector, options = {}) {
    // The navigation element selector.
    if (selector) {
      this.options = Foundation.extend({
        "mobileNavType": "-none-"
      }, options || {})

      var regularSetup = function () {
        jQuery(`${selector} .subnav_link`).each(function () {
          var navigationID = jQuery(this).attr('id')
          var navigationSelector = `#${navigationID}`
          var navMenuSelector = `${selector} #SNAV_${navigationID.split('_')[1]}`
          var navigationTimeout
          var focusNavigation = function () {
            clearTimeout(navigationTimeout)
            jQuery(navMenuSelector).css('left', `${Math.round(jQuery(navigationSelector).position().left)}px`)
            jQuery(navMenuSelector).show()
          }
          var blurNavigation = function () {
            jQuery(navMenuSelector).hide()
            navigationTimeout = setTimeout(function () {}, 75)
          }
          jQuery(`${navMenuSelector}, ${navigationSelector}`).hover(focusNavigation, blurNavigation)
        })
      }

      // Tablet/Mobile Mode -- behavior for viewing of the desktop site with mobile devices
      if (navigator.userAgent.match(/\b(iPad|iPhone|iPod|Android|Pre|BlackBerry|Windows Phone)\b/i)) {
        // -none- - Do the regular nav
        if (this.options['mobileNavType'] === '-none-') {
          regularSetup()

        // clickMenus - The navigation items do not click through and Tapping the navigation items shows the drop-down menus.
        }
        else if (this.options['mobileNavType'] === 'clickMenus') {
          var navLinkSelector = `${selector} .subnav_link`
          var navMenuPrefix = `${selector} #SNAV_`
          var navAllMenuSelector = `${selector}> [id^=SNAV_]`
          var subNavSelector = '.subnav_content'
          var navCurrentItemSelector = ''

          // Stop iOS from clicking through
          jQuery(navLinkSelector).each(function () {
            jQuery(this)[0].onclick = function (e) {
              e.preventDefault()
              return false
            }
          })

          var navigationMenu = function (itemSelector, menuSelector, allMenuSelector) {
            var focusNavigation = function (e) {
            e.stopImmediatePropagation()
            e.stopPropagation()
            e.preventDefault()
            if (itemSelector === navCurrentItemSelector && jQuery(menuSelector).is(':visible')) {
              blurNavigation(e)
            }
            else {
              jQuery(allMenuSelector).hide()
              navCurrentItemSelector = itemSelector
              jQuery(menuSelector).css('left', `${Math.round(jQuery(itemSelector).position().left)}px`)
              jQuery(menuSelector).show()
              jQuery(document).on('touchstart', blurNavigation)
            }
            }
            var blurNavigation = function (e) {
            if (jQuery(e.target).closest(subNavSelector).length === 0) {
              jQuery(allMenuSelector).hide()
              jQuery(document).off('touchstart', blurNavigation)
            }
            }
            jQuery(itemSelector).on('touchstart', focusNavigation)
          }

          jQuery(navLinkSelector).each(function () {
            var navigationID = jQuery(this).attr('id')
            var navItemSelector = `#${navigationID}`
            var navMenuSelector = navMenuPrefix + navigationID.split('_')[1]
            navigationMenu(navItemSelector, navMenuSelector, navAllMenuSelector)
          })
        }

      // Desktop Mode
      }
      else {
        regularSetup()
      }
    }
  }
}

window["Foundation"]["View"]["Desktop"]["NavigationPanel"] = Foundation.View.Desktop.NavigationPanel
